import { render } from "./CoursesContent.vue?vue&type=template&id=264f7382&ts=true"
import script from "./CoursesContent.vue?vue&type=script&lang=ts"
export * from "./CoursesContent.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__